module.exports = __webpack_public_path__ + "img/flowers.f968194.webp";